export { default } from "./InputButtonsSameSize";
